// Reward labels are display-only; the backend still owns eligibility and payment.
export function normalizeRegisterReward(value) {
    if (!['string', 'number'].includes(typeof value)) return ''
    const text = String(value).trim()
    if (!/[1-9]/.test(text) || /^[^\d]*-\s*\d/.test(text)) return ''
    return text
}

export function registrationRewardFromHome(data = {}) {
    const activities = [data?.eventManageList, data?.eventPopupList]
        .filter(Array.isArray).flat()
        .filter(activity => activity?.eventType === 'registerRewards')
    // homeShow currently leaves enableState null on returned activities. In that
    // case require a current returned registration activity, never a cached label.
    // Honor explicit enable/disable values; unknown explicit states fail closed.
    if (activities.some(activity => {
        const state = activity.enableState == null ? '' : String(activity.enableState).trim().toLowerCase()
        return state && state !== 'enable'
    })) return ''
    for (const activity of activities) {
        const reward = normalizeRegisterReward(activity.eventRewardDescription)
        if (reward) return reward
    }
    return ''
}
